module.exports = __webpack_public_path__ + "img/y-14.01895c85.png";